import { Injectable } from '@angular/core';
import { ToastService } from '../../../domains/shared/components/toast/services/toast.service';

export interface MessageOptions {
    duration?: number;
    title?: string;
    timeOut?: number;
}

export const notCloseMessageOptions: MessageOptions = {
    duration: 0
};

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    constructor(private toastService: ToastService) {}

    /**
     * Exibe uma mensagem de sucesso
     */
    success(message: string, title?: string, options?: MessageOptions) {
        this.toastService.success(message, {
            title,
            duration: this.extractDuration(options)
        });
    }

     /**
      * Exibe uma mensagem de informação
      */
    info(message: string, title?: string, options?: MessageOptions) {
        this.toastService.info(message, {
            title,
            duration: this.extractDuration(options)
        });
    }

    /**
     * Exibe uma mensagem de atenção
     */
    warning(message: string, title?: string, options?: MessageOptions) {
        this.toastService.warning(message, {
            title,
            duration: this.extractDuration(options)
        });
    }

    /**
     * Exibe uma mensagem de erro
     * Por padrão a mensagem não fecha automaticamente
     */
    error(message: string, title?: string, error?: any, options?: MessageOptions) {
        if (error) {
            console.error(error);
        }

        this.toastService.error(message, {
            title,
            duration: this.extractDuration(options, 0)
        });
    }

    /** Exibe uma mensagem de confirmação ao usuário */
    confirm(message: string, title?: string): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            const result = window.confirm(message);
            resolve(result);
        });
    }

    private extractDuration(options?: MessageOptions, defaultDuration?: number): number | undefined {
        if (!options) {
 return defaultDuration;
}

        if ('duration' in options) {
            return options.duration;
        }

        if ('timeOut' in options) {
            return options.timeOut;
        }

        return defaultDuration;
    }
}
